import {useIsInTransitEnabled} from '../../hooks/useIsInTransitEnabled';

export function InTransitChip({isInTransit, className}: {isInTransit?: boolean; className?: string}) {
	const isInTransitEnabled = useIsInTransitEnabled();
	if (!isInTransitEnabled || !isInTransit) {
		return null;
	}
	return (
		<div className={`inline-flex items-center rounded-full bg-primary text-white px-3 py-1 text-xs${className ? ` ${className}` : ''}`}>
			In Transit
		</div>
	);
}
